import { Reveal } from "./Reveal";
import { RitualSeal } from "./RitualSeal";
import { whatsappLink } from "../config/site";
import { useLang } from "../config/i18n";

export const FinalCTA = () => {
  const { t } = useLang();

  return (
    <section id="contato" data-testid="final-cta-section" className="relative py-28 sm:py-40 overflow-hidden border-t border-[#22222B]">
      <RitualSeal className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] text-[#C5A059] opacity-[0.09] pointer-events-none" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(197,160,89,0.08),transparent_65%)] pointer-events-none" />
      <div className="relative max-w-3xl mx-auto px-6 text-center">
        <Reveal>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl text-[#F7F7F8] leading-snug mb-8">
            {t.finalCta.title1} <span className="gold-text">{t.finalCta.title2}</span>
          </h2>
          <p className="text-[15px] sm:text-base text-[#A3A3AF] leading-relaxed font-light mb-12">
            {t.finalCta.text}
          </p>
          <a
            data-testid="final-cta-whatsapp-btn"
            href={whatsappLink(t.waDefault)}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-gold min-h-[60px] px-12"
          >
            {t.finalCta.cta}
          </a>
          <p className="mt-8 text-xs tracking-[0.2em] uppercase text-[#6E6E7D]">
            {t.finalCta.note}
          </p>
        </Reveal>
      </div>
    </section>
  );
};
